import FeedviewContainer from './Feedview';

export default FeedviewContainer;
